<template>
  <div class="zg-user-info">
    <span class="_btn-pre"><button @click="onPre" :class="disablePre ? '_btn-disable' : ''" type="button"><i class="cicon-pagination-prev"></i></button></span>
    <div class="_center">
      <user-info-props></user-info-props>
      <user-info-sessions :uid="uid"></user-info-sessions>
    </div>
    <span class="_btn-next"><button @click="onNext" :class="disableNext ? '_btn-disable' : ''" type="button"><i class="cicon-pagination-next"></i></button></span>
  </div>
</template>
<script>
import userInfoProps from './props'
import userInfoSessions from './sessions'
import { actions } from '../../store/constants'
export default {
  name: 'userInfo',
  components: {
    userInfoProps,
    userInfoSessions
  },
  props: {
    uid: {
      type: Number,
      required: true
    },
    disablePre: {
      type: Boolean,
      default: false
    },
    disableNext: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  watch: {
    uid (uid) {
      this.initData()
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.getRecentEvents()
      this.getInfo()
    },
    getEventMeta () {
      this.$store.dispatch(actions.biz.sys.queryEventMeta, {
        appId: this.appId,
        platform: this.platform
      })
    },
    getRecentEvents () {
      this.$store.dispatch(actions.userInfo.getInfo, {
        appId: this.appId,
        platform: this.platform,
        uidList: this.uid,
        showSimple: true,
        cdpId: 0
      })
    },
    getInfo () {
      this.$store.dispatch(actions.userInfo.getInfo, {
        appId: this.appId,
        platform: this.platform,
        uidList: this.uid,
        cdpId: 0
      })
    },
    onNext () {
      if (!this.disableNext) this.$emit('next')
    },
    onPre () {
      if (!this.disablePre) this.$emit('pre')
    }
  }
}
</script>
<style lang="sass">
@import './styles/index.sass'
</style>